import { IonicModule } from '@ionic/angular';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { BackButtonModule } from '../../components/back-button/back-button.component.module';
import { PrimePage } from './prime.component';
import { HeaderModule } from '../../components/header/header.module';
import { SafeHtmlsModule } from '../../angular-wallet-base/pipes/safe-htmls/safe-htmls.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { TabsModule } from '../../components/home-page/tabs/tabs.module';
import { NgxKjuaModule } from 'ngx-kjua';
import { SelectAssetModule } from '../select-asset-modal/select-asset-modal.module';
import { KycModalModule } from '../../components/kyc-modal/kyc-modal.module';
import { CustomCurrencyPipeModule } from '../../angular-wallet-base/pipes/customcurrency/customcurrency.module';
import { SmallToCryptoPipeModule } from '../../angular-wallet-base/pipes/smalltocrypto/smalltocrypto.module';
import { DebounceDirectiveModule } from '../../angular-wallet-base/directives/debounce/debounce-directive.module';
import { CustomCurrencyPipe } from '../../angular-wallet-base/pipes/customcurrency/customcurrency.pipe';
import { PrimeAssetComponent } from './prime-asset/prime-asset.component';
import { TransactionDetailsComponent } from './transaction-details/transaction-details.component';
import { PrimeTosComponent } from './prime-tos/prime-tos.component';
import { SafePipe } from 'src/app/angular-wallet-base/pipes/safe-urls/safe-urls-pipe';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { File } from '@ionic-native/file/ngx';
import { DocumentViewer } from '@ionic-native/document-viewer/ngx';
import { DepositFundsModalComponent } from './deposit-funds-modal/deposit-withdraw-funds-modal';
import { USDBalanceHomeModal } from './usd-balance-modal/usd-balance-modal';
import { SuccessDepositModalComponent } from './success-deposit-modal/success-deposit-modal';
import { MatSelectModule } from '@angular/material/select';

const routes: Routes = [
  {
    path: '',
    component: PrimePage,
  },
  { path: 'tranDetails', component: TransactionDetailsComponent },
  { path: 'token-page', component: PrimeAssetComponent },
];
@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    TabsModule,
    RouterModule.forChild(routes),
    BackButtonModule,
    HeaderModule,
    SafeHtmlsModule,
    NgApexchartsModule,
    NgxKjuaModule,
    SelectAssetModule,
    KycModalModule,
    SmallToCryptoPipeModule,
    DebounceDirectiveModule,
    MatSelectModule,
    CustomCurrencyPipeModule
  ],
  declarations: [
    PrimePage,
    TransactionDetailsComponent,
    PrimeTosComponent,
    //ach banking related components
    DepositFundsModalComponent,
    USDBalanceHomeModal,
    SuccessDepositModalComponent,
    SafePipe,
  ],
  providers: [
    FileTransfer,
    File, 
    DocumentViewer
  ],
})
export class PrimeModule {}
